import React from "react";

import { TextField } from "@graffer-inc/console-design-kit";
import { UpdateKintoneExportSettingInput } from "@graffer-inc/smart-apply";

export const KintoneAPITokenInput: React.FC<{
  kintoneApiToken: UpdateKintoneExportSettingInput["kintoneAPIToken"];
  onChange: (
    kintoneApiToken: UpdateKintoneExportSettingInput["kintoneAPIToken"],
  ) => void;
}> = ({ kintoneApiToken, onChange }) => {
  const [value, setValue] = React.useState("");
  const [isFocused, setFocused] = React.useState(false);

  React.useEffect(() => {
    setValue(kintoneApiToken ? kintoneApiToken : isFocused ? "" : "********");
  }, [kintoneApiToken, setValue, isFocused]);

  return (
    <div className="columns">
      <div className="column">
        <TextField
          label="kintone API トークン"
          value={value}
          onChange={(e) => {
            if (e.target.value?.length > 0) {
              onChange(e.target.value);
            } else {
              onChange(null);
            }
          }}
          placeholder="更新したくない場合は、入力内容を削除してください。"
          description={"kintone API トークンを更新することができます。"}
          onFocus={() => {
            setFocused(true);
          }}
          onBlur={() => {
            setFocused(false);
          }}
        />
      </div>
    </div>
  );
};
